// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { mergeClasses } from 'util/commons';
import './LoadingModal.scss';
import { LoadingSpiner } from 'components/atoms/LoadingSpiner';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type LoadingModalProps = {
  isOpen?: boolean;
  zIndex?: number;
  closeAction?: {
    timeout?: number;
    onClose: () => void;
  };
};

export const LoadingModal = ({
  isOpen,
  zIndex = 100000,
  closeAction,
}: LoadingModalProps) => {
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const { t } = useTranslation();

  const resetTimeout = () => {
    setShowCloseButton(false);

    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
      timeOutRef.current = null;
    }
  };

  useEffect(() => {
    resetTimeout();

    if (isOpen && closeAction) {
      timeOutRef.current = setTimeout(() => {
        setShowCloseButton(true);
        timeOutRef.current = null;
      }, closeAction.timeout ?? 5 * 60 * 1000); // default 5 minutes
    }

    return () => {
      resetTimeout();
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <section className="loading-modal" style={{ zIndex }}>
      <div>
        <LoadingSpiner />

        {showCloseButton && closeAction && (
          <button
            className={mergeClasses('loading-modal-close-button')}
            onClick={() => {
              closeAction.onClose();
              resetTimeout();
            }}
          >
            {t('common.button.hide')}
          </button>
        )}
      </div>
    </section>
  );
};
